/**
 * Derives WebP responsive-variant URLs for the property photos processed by
 * the server-side FFmpeg batch pipeline (`properties/{name}.jpg` ->
 * `{name}-thumb.webp` / `{name}-medium.webp` / `{name}.webp`, originals left
 * untouched). Only `/media/properties/*.jpg` has variants — maintenance
 * photos and any future upload were never batch-processed — so a null
 * return means "no variant, render the original file".
 */
const PROPERTY_JPG = /\/media\/properties\/[^/]+\.jpe?g$/i;

export type ImageVariantSize = 'thumb' | 'medium' | 'full';

export function webpVariantUrl(originalUrl: string, size: ImageVariantSize): string | null {
  if (!PROPERTY_JPG.test(originalUrl)) return null;
  const suffix = size === 'full' ? '' : `-${size}`;
  return originalUrl.replace(/\.jpe?g$/i, `${suffix}.webp`);
}
